import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useGiveawayStore from '@/stores/GiveawayStore';
import SettingsPanel from '../SettingsPanel';
import { useShallow } from 'zustand/react/shallow';
import { Switch, Text, TextInput } from '@mantine/core';
import styles from './GiveawayKeywordStep.module.scss';
import GiveawayCreateFooter from './GiveawayCreateFooter';
import useIntlMemo from '@/hooks/useIntlMemo';
import ErrorNotice from '../ErrorNotice';
import GiveawayWinnerMessageSetting from './GiveawayWinnerMessageSetting';
import GiveawayLuckSettings from './GiveawayLuckSettings';
export default function GiveawayKeywordStep(param) {
    var onBack = param.onBack, onNext = param.onNext;
    var intl = useIntl();
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            phrase: state.phrase,
            setPhrase: state.setPhrase,
            preventPhraseSpam: state.preventPhraseSpam,
            setPreventPhraseSpam: state.setPreventPhraseSpam,
            uniqueWinners: state.uniqueWinners,
            setUniqueWinners: state.setUniqueWinners
        };
    })), phrase = _useGiveawayStore.phrase, setPhrase = _useGiveawayStore.setPhrase, preventPhraseSpam = _useGiveawayStore.preventPhraseSpam, setPreventPhraseSpam = _useGiveawayStore.setPreventPhraseSpam, uniqueWinners = _useGiveawayStore.uniqueWinners, setUniqueWinners = _useGiveawayStore.setUniqueWinners;
    var errorMessage = useIntlMemo(function(intl) {
        if (phrase.length === 0) {
            return intl.formatMessage({
                id: "wotZIu",
                defaultMessage: [
                    {
                        type: 0,
                        value: "The phrase cannot be empty."
                    }
                ]
            });
        } else if (phrase.length > 32) {
            return intl.formatMessage({
                id: "JfR+Pd",
                defaultMessage: [
                    {
                        type: 0,
                        value: "The phrase cannot be longer than 32 characters."
                    }
                ]
            });
        }
        return null;
    }, [
        phrase,
        intl
    ]);
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                className: styles.subHeading,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "pNPUaU",
                    defaultMessage: "Configure the settings for the giveaway."
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                className: styles.settingsPanel,
                afterElementContainerProps: {
                    className: styles.afterElementContainer
                },
                heading: intl.formatMessage({
                    id: "fe0rMF",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Keyword"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "/KSAaz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "The phrase that users must type to enter the giveaway."
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(TextInput, {
                    className: styles.textInput,
                    variant: "outline",
                    placeholder: intl.formatMessage({
                        id: "c6L962",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "!join"
                            }
                        ]
                    }),
                    value: phrase,
                    error: phrase.length === 0,
                    onChange: function(e) {
                        return setPhrase(e.target.value);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ErrorNotice, {
                children: errorMessage
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                className: styles.settingsPanel,
                heading: intl.formatMessage({
                    id: "mULI+y",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Remove Spammers"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    checked: preventPhraseSpam,
                    onChange: function(e) {
                        return setPreventPhraseSpam(e.target.checked);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                className: styles.settingsPanel,
                heading: intl.formatMessage({
                    id: "UnFLxJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Unique Winners"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Switch, {
                    checked: uniqueWinners,
                    onChange: function(e) {
                        return setUniqueWinners(e.target.checked);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(GiveawayWinnerMessageSetting, {}),
            /*#__PURE__*/ _jsx(GiveawayLuckSettings, {}),
            /*#__PURE__*/ _jsx(GiveawayCreateFooter, {
                backButtonProps: {
                    onClick: onBack
                },
                nextButtonProps: {
                    disabled: phrase.length === 0,
                    onClick: onNext
                },
                nextText: intl.formatMessage({
                    id: "JXdbo8",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Done"
                        }
                    ]
                })
            })
        ]
    });
}
